var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutDarkGrey48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.381 0C32.8274 0 34 1.14754 34 2.56311V19.3398H32.5714V2.56311C32.5714 1.91967 32.0384 1.39806 31.381 1.39806H6.61905C5.96157 1.39806 5.42857 1.91967 5.42857 2.56311V45.4369C5.42857 46.0803 5.96157 46.6019 6.61905 46.6019H31.381C32.0384 46.6019 32.5714 46.0803 32.5714 45.4369V28.6602H34V45.4369C34 46.8525 32.8274 48 31.381 48H6.61905C5.17259 48 4 46.8525 4 45.4369V2.56311C4 1.14754 5.17259 0 6.61905 0H31.381Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.412 19.2187C40.6824 18.9271 41.1215 18.9271 41.3919 19.2187L45.7972 23.972C46.0676 24.2636 46.0676 24.7364 45.7972 25.0281L41.3919 29.7813C41.1215 30.0729 40.6824 30.0729 40.412 29.7813C40.1417 29.4897 40.1417 29.0159 40.412 28.7243L43.6365 25.2469H13V23.7532H43.6365L40.412 20.2758C40.1417 19.9841 40.1417 19.5104 40.412 19.2187Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDarkGrey48);
export default __webpack_public_path__ + "static/media/Logout_dark_grey48.f47f66016bf86c9959cf36943874ef92.svg";
export { ForwardRef as ReactComponent };